<template>
    <section class="content">
        <table class="table table-hover" ref="tablesuswa">
            <thead>
                <tr>
                    <th>TANGGAL UJIAN</th>
                    <th>MAPEL</th>
                    <th>NAMA UJIAN</th>
                    <th>NILAI</th>
                </tr>
            </thead>
            <tbody @click="handleClick">
            </tbody>
        </table>
    </section>
    <!-- /.content -->
</template>
<script>
import { createTable, authFetch, auth } from '@/libs/hxcore';
import $ from 'jquery';
import datepicker from '@/components/Datepicker';
import Swal from "sweetalert2";
import moment from "moment";

export default {
    name: 'Siswalist',
    data() {
        return {
            errors: [],
            filter: {},
            siswa: {},
            method: '',
            roles: '',
            id: '',
            branch: '',
            userid: '',
        }
    },
    components: {
        datepicker
    },
    created: function() {
        this.roles = this.$route.meta.roles;
        console.log('load initial data', this.$route)
        // this.id = this.$route.params.id
        // this.branch = this.$route.params.branch
        // this.userid = auth.user().id;
    },
    methods: {
        handleClick(e) {
            if (e.target.matches('.link-role')) {
                this.$router.push({ path: '/permit/' + e.target.dataset.id })
                return false;
            }
        },
    },
    mounted() {
        const e = this.$refs;
        var self = this;
        this.table = createTable(e.tablesuswa, {
            "title": "Rapor Evaluasi",
            "roles": ["read"],
            "ajax": "/siswa/ujian/hasil_ujian",
            "columns": [
                { "data": "tanggal",
                render: function (data, type, row, meta) {
                    return moment(data).format("DD/MM/YYYY hh:mm:ss");
                } },
                { "data": "mapel" },
                { "data": "ujian_title" },
                { "data": "final_score" },
            ],
            filter: false,
            scrollX: true,
            rowCallback: function(row, data) {
            },
            paramData: function(d) {
                // d.ujian_type = self.$route.params.ujian_type;
                var filter = JSON.parse(JSON.stringify(self.$route.params.filter));
                for (const key in filter) {
                    d[key] = filter[key] === false ? 0 : filter[key];
                }
            },
        });
    }
}
</script>
<style type="text/css">
    /* Chrome, Safari, Edge, Opera */
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }

    /* Firefox */
    input[type=number] {
      -moz-appearance: textfield;
    }
</style>